import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table";
import { subscriptions } from "../../../../../../redux/subscriptions/action";
import { selectChapterSubscriptionListItems } from "../../../../../../redux/chapter/subscriptions/selector";
import { chapterSubscription } from "../../../../../../redux/chapter/subscriptions/action";


const ChapterSubscriptions = () => {
    const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);

    const SubscriptionsItems = useSelector(selectChapterSubscriptionListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
         
          { field: 'CommunityChapterName', headerName: 'CommunityChapterName', searchField: 'CommunityChapterName', filter: true,
            filterType: 'text' },
            { field: 'FirstName', headerName: 'First Name'},
            { field: 'LastName', headerName: 'Last Name'},
           
 

        ]);
      }


      const handleSearch = (data: any) => {
      
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "CommunityChapterName",
            FieldText: "CommunityChapterName",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(chapterSubscription.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/subscriptions/list`,entity:'chapterSubscriptions',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
          }}))
      }
    
       const fetchSubscriptions=()=>{
        dispatch(chapterSubscription.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/subscriptions/list`,entity:'chapterSubscriptions',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }

      const handleReloadData = () => {
       fetchSubscriptions()
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
      const handleEdit=(data: any)=>{
        navigate(`${data?.Id}`)
      }
        
     
     
      const additionButtons: any = [
      
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        
        callback: () => handleReloadData(),
        },
      ];
    useEffect(() => {
        createColumnDefs()
        fetchSubscriptions()
    }, [pageData,pageSize])
  const handleDelete=(data: any)=>{
    dispatch(chapterSubscription.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/subscriptions/delete`,
      entity: 'chapterSubscriptions',
      jsonData: {
        Records: [
          {
         
                Id: data?.Id
            }
          
        ]
      }
  })).then(() => {
    dispatch(chapterSubscription.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/subscriptions/list`,entity:'chapterSubscriptions',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": pageSize,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
  });
  }
    return (
    <>
    {SubscriptionsItems?.isLoading ?  <PageLoader />: 
        <Table   enableFilter={true}
    filterTypeLists={filterTypes}
    onSearch={handleSearch} columnData={columnDefs} rowData={SubscriptionsItems?.result?.items} setPageData={setPageData}
    setPageSize={setPageSize}paginationData={SubscriptionsItems?.result?.pagination}  additionButtons={additionButtons} onDelete={handleDelete}headingName="Subscriptions"/>
     
  }
  </> 
    );
};

export default ChapterSubscriptions;